import React from 'react';
import { TONE_TEXT } from '../../utils/statusColors';
import { MarcaDoGrupoSolto, textoDaMarcaDoGrupo } from '../../utils/grupoNaLista';

/**
 * A marca discreta do grupo de uma empresa só (decisão G1 do Heitor, 03/11/2026), a mesma em Assinaturas e Faturas:
 * a linha é a de sempre, sem moldura, e a marca diz que há grupo e quantas empresas dele estão ativas.
 */
export default function MarcaDoGrupo({ marca }: { marca: MarcaDoGrupoSolto }) {
  return (
    <p className={`text-[11px] mt-0.5 truncate ${TONE_TEXT.group}`} data-marca-do-grupo title="Grupo econômico sem divisão do compartilhado: só uma empresa está no rateio vigente">
      {textoDaMarcaDoGrupo(marca)}
    </p>
  );
}
